import React, { useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import "../styles/Admin.css";

const CHECK_ADMIN = gql`
  query CheckAdmin($email: String!, $password: String!) {
    admins(where: { email: { _eq: $email }, password: { _eq: $password } }) {
      id
      email
    }
  }
`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [runCheck, { loading }] = useLazyQuery(CHECK_ADMIN, { fetchPolicy: "network-only" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await runCheck({ variables: credentials });
      if (data && data.admins && data.admins.length > 0) {
        navigate("/admin");
      } else {
        alert("Identifiants invalides");
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Erreur de connexion:", err);
      alert("Erreur de connexion. Veuillez réessayer.");
    }
  };

  return (
    <div className="admin-login-wrap">
      <div className="admin-login-card">
        <h2 className="admin-login-title">Connexion Administrateur</h2>
        <p className="admin-login-sub">Accédez au tableau de bord sécurisé</p>
        <form onSubmit={handleSubmit} className="form-row">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              className="form-input"
              type="email"
              id="email"
              name="email"
              value={credentials.email}
              onChange={handleChange}
              required
              autoComplete="username"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              className="form-input"
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              required
              autoComplete="current-password"
            />
          </div>
          <button className="form-submit" type="submit" disabled={loading}>
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
